import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { OrderWizardDto } from "../../model/order-wizard.model";
import { delay, map, Observable, of, switchMap, tap } from "rxjs";
import { OrderWizardSelectionDto } from "../../model/order-wizard.selection.model";
import { OrderDto } from "../../model/order.model";
import { CurrencyPurchaseSelectionDto } from "../../../front-pages/common/fp-order-panel/fp-order-purchase/model/currency-purchase.selection.model";
import { SessionUpdateRequest } from "../../../../../shared/session/session-update-request.model";
import { CurrencyPurchaseDto } from "../../../front-pages/common/fp-order-panel/fp-order-purchase/model/currency-purchase.model";
import { SessionService } from "src/app/shared/session/session-service";
import { CustomerDto } from "../../model/customer.model";
import { ResultUrl } from "../../model/result-url.model";

@Injectable({ providedIn: 'root' })
export class OrderWizardApi {
    constructor(
        private _httpClient: HttpClient,
        private _sessionService: SessionService
    ) { }
    delayMs: number = 100;

    init(orderWizardDto: OrderWizardDto | null): Observable<OrderWizardDto> {

        if(orderWizardDto){
            return this._httpClient
                .post<OrderWizardDto>(`api/order/wizard/init`, orderWizardDto, { withCredentials: true })
                .pipe(switchMap(x => {
                    return this.initSession(x);
                }));
        } else {
            return this.initSession(null);
        }
    }

    private initSession(x: OrderWizardDto | null): Observable<OrderWizardDto> {
        var requestType = x ? 'InitWizardWithData' : 'LoadWizardFromSession';
        return this._sessionService
            .Update({
                sessionId: "",
                requestType: requestType,
                currentUrl: window.location.href,
                wizardData: x
            }).pipe(
        //         tap(response => {
        //     // console.log('--> update response', response);
        // }),
                map(x => x.wizardData ?? new OrderWizardDto())
            );
    }

    addCurrencyPurchase(orderDto: OrderDto) {
        return this._httpClient
            .post<OrderDto>(`api/order/wizard/add-currency-purchase`, orderDto, { withCredentials: true })
    }

    load(orderCode: string): Observable<OrderWizardDto> {
        return this._httpClient
            .get<OrderWizardDto>(`api/order/wizard/order/${orderCode}`, { withCredentials: true });
    }

    initiatePayment(): Observable<string> {
        return this._httpClient
            .get(`api/stripe/payment/initiate`, { responseType: 'text' });
    }

    save(orderWizardDto: OrderWizardDto): Observable<OrderWizardDto> {
          return this._httpClient
            .post<OrderWizardDto>(`api/order/wizard/save`, orderWizardDto, { withCredentials: true })
            .pipe(
                delay(this.delayMs) // délai en millisecondes
            );
    }

    changeItem(item: CurrencyPurchaseDto): Observable<CurrencyPurchaseDto> {
        return this._httpClient
            .post<CurrencyPurchaseDto>(`api/order/calculation/currency-purchase`, item, { withCredentials: true })
            .pipe(
                delay(this.delayMs) // délai en millisecondes
            );
    }

    changePricingSummary(order: OrderDto): Observable<OrderDto> {
          return this._httpClient
            .post<OrderDto>(`api/order/calculation/pricing-summary`, order, { withCredentials: true })
            .pipe(
                delay(this.delayMs) // délai en millisecondes
            );
    }

    emailValidationSend(customerDto: CustomerDto): Observable<CustomerDto>{ 
        return this._httpClient
            .post<CustomerDto>(`api/customer/email-validation/send-code`, customerDto, { withCredentials: true })
            .pipe(
                delay(this.delayMs) // délai en millisecondes
            );
    }

    emailValidationSetTimeout(customerDto: CustomerDto): Observable<ResultUrl<CustomerDto>>{ 
        return this._httpClient
            .post<ResultUrl<CustomerDto>>(`api/customer/email-validation/set-timeout`, customerDto, { withCredentials: true })
            .pipe(
                delay(this.delayMs) // délai en millisecondes
            );
    }

    emailCheckIsValidated(idCustomer: number) {
        return this._httpClient
            .get<CustomerDto>(`api/customer/${idCustomer}/email-validation/check-is-validate`, { withCredentials: true });
    }

    getSelection(orderWizardDto?: OrderWizardDto) {
        // return of(this.mockDataSelection);
        return this._httpClient
            .post<OrderWizardSelectionDto>(`api/order/wizard/selection`, orderWizardDto, { withCredentials: true })
    }

    updateSession(request: SessionUpdateRequest): Observable<SessionUpdateRequest> {
        return this._httpClient
            .post<SessionUpdateRequest>(`api/session/update`, request, { withCredentials: true });
    }
}
